import { render, staticRenderFns } from "./ContentTrend.vue?vue&type=template&id=5d7ebc88"
import script from "./ContentTrend.vue?vue&type=script&lang=js"
export * from "./ContentTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports